<div placement="top" [ngbTooltip]="text">
  <fa-icon [icon]="icon"></fa-icon>
</div>
